// extracted by css-extract-rspack-plugin
export default {"heading":"KYqfSh","dividerHalfLarge":"TCMsQw"};